import React from 'react';
import HtmlReactParser from 'html-react-parser';
import styled from 'styled-components';
import { H1, P, UtilityHeader, Footer, SideNav, Button, BREAKPOINTS } from '@awesomecomponents/mux';
import { buildFooterMenus, buildHeaderRight } from '../utils/navigationBuilder';
import { appConstants } from '../utils/appConstants';
import { useLocation } from 'react-router-dom';
import { getLogoutLang } from '../utils/modalFunctions';

const ButtonWrapper = styled.div`
  display: flex;
  margin: 40px 0;

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    margin: 0;
  }
`;

const HeaderContainer = styled.div`
  position: relative;
`;

const Wrapper = styled.div`
  white-space: pre-wrap;
`;
const ContentHeader = styled.div`
  position: relative;
  min-height: calc(10px);
  margin: 2%;
`;

const Content = styled.div`
  position: relative;
  min-height: calc(100vh - 250px);
  margin: 2.5%;
`;
const Container = styled.main`
  position: absolute;
  top: 40px;
  left: 100px;
  right: 0;
  bottom: 0;
  overflow: auto;

  @media (max-width: ${BREAKPOINTS.MAX_1600}px) {
    left: 80px;
  }

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    top: 60px;
    left: 0;
  }
`;

const SideNavWrapper = styled.div`
  & nav {
    overflow-y: hidden;
  }
`;

const Logout = ({ langContent, isPublic }) => {
  const { state } = useLocation();
  const { language: lang = appConstants.MANULIFE_EN_LANG } = state;
  const content = getLogoutLang(langContent[lang], state);

  const navigateToManulife = () => {
    window.location.assign(appConstants.MANULIFE_URL);
  };

  const { HEADER, HEADER_WITHOUT_AUTH, CONTENT_WITH_AUTH, CONTENT_WITHOUT_AUTH, BUTTON_OK } = content;
  return (
    <>
      <HeaderContainer>
        <UtilityHeader
          rightItems={buildHeaderRight(lang)}
          rightMobileItems={buildHeaderRight(lang)}
          showLangToggle={false}
          showSignin={false}
          lang={lang}
          tabIndex={1}
        />
        <SideNavWrapper>
          <SideNav lang={lang} showSignIn={false} showContactUs={false} tabIndex={2} />
        </SideNavWrapper>
      </HeaderContainer>
      <Container id="mainContainer">
        <ContentHeader>
          <H1>{HtmlReactParser(!isPublic ? HEADER : HEADER_WITHOUT_AUTH)}</H1>
        </ContentHeader>
        <Content>
          <Wrapper>
            <P>{HtmlReactParser(!isPublic ? CONTENT_WITH_AUTH : CONTENT_WITHOUT_AUTH)}</P>
          </Wrapper>
          <ButtonWrapper>
            <Button
              id="formhero-ok-button"
              data-testid="formhero-ok-button"
              ariaLabel="navigate to manulife"
              onClick={() => navigateToManulife()}
            >
              {BUTTON_OK}
            </Button>
          </ButtonWrapper>
        </Content>
        <Footer items={buildFooterMenus(lang)} lang={lang} tabIndex={40} />
      </Container>
    </>
  );
};

export default Logout;
